import { Cube, ShoppingBag, Storefront, Truck, CurrencyEur } from "@phosphor-icons/react";
import { eur, number } from "../shared";

const METRICS = [
  ["stuks", "Totaal stuks", Cube],
  ["bestellingen", "Bestellingen", ShoppingBag],
  ["actieve_bestemmingen", "Actieve bestemmingen", Storefront],
  ["leveranciers", "Leveranciers", Truck],
];

export const CtnReportStats = ({ data }) => <>
  <dl className="ctn-report-metrics">
    {METRICS.map(([key, label, Icon]) => <div className="ctn-report-metric" key={key}>
      <dt><span>{label}</span><Icon size={19} aria-hidden="true" /></dt>
      <dd data-testid={`ctn-report-${key.replaceAll("_", "-")}`}>{number(data[key])}</dd>
    </div>)}
  </dl>
  {(data.aankoopwaarde_eur != null || data.verkoopwaarde_eur != null) && <dl className="ctn-report-values">
    {[["aankoop", "Totale aankoopwaarde (EUR)"], ["verkoop", "Totale verkoopwaarde (EUR)"]].map(([key, label]) => data[`${key}waarde_eur`] != null && <div key={key} className={`ctn-report-value ctn-report-value-${key}`}>
      <dt>{label}<CurrencyEur size={18} aria-hidden="true" /></dt>
      <dd data-testid={`ctn-report-${key}waarde-eur`}>{eur(data[`${key}waarde_eur`])}</dd>
      {data[`zonder_${key}prijs`] > 0 && <p data-testid={`ctn-report-missing-${key}-prices`}>{number(data[`zonder_${key}prijs`])} bestelling(en) zonder {key}prijs</p>}
    </div>)}
  </dl>}
</>;